function writeSessionStorage(key, value) {
    try {
        return window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch {
        return null;
    }
}

function readSessionStorage(key) {
    try {
        return JSON.parse(window.sessionStorage.getItem(key));
    } catch {
        return null;
    }
}

export {writeSessionStorage, readSessionStorage};
